import { resolveComponent as _resolveComponent, withKeys as _withKeys, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df111dcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "q-ml-xs"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
    tag: "label",
    onClick: _ctx.selectAsset,
    class: _normalizeClass(["with-q-radio", { active: _ctx.assetKey === _ctx.model, warning: _ctx.isInBrief }])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, { side: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_radio, _mergeProps({
            color: _ctx.isInBrief ? 'warning' : 'primary'
          }, _ctx.RADIO_PROPS, {
            onKeyup: _withKeys(_ctx.goNextStep, ["enter"]),
            "onUpdate:modelValue": [
              _ctx.selectAsset,
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event))
            ],
            modelValue: _ctx.model,
            val: _ctx.assetKey
          }), null, 16, ["color", "onKeyup", "onUpdate:modelValue", "modelValue", "val"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, { side: "" }, {
        default: _withCtx(() => [
          (!_ctx.isNew)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                name: _ctx.icon
              }, null, 8, ["name"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, _mergeProps({ lines: 1 }, _ctx.TEXT_CONTENT_BODY), {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.asset.name), 1)
            ]),
            _: 1
          }, 16),
          (_ctx.isNew)
            ? (_openBlock(), _createBlock(_component_q_item_label, {
                key: 0,
                caption: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t('NEW_ASSET_HINT')), 1)
                ]),
                _: 1
              }))
            : (_ctx.isInBrief)
              ? (_openBlock(), _createBlock(_component_q_item_label, {
                  key: 1,
                  caption: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t('IN_THIS_BRIEF', { brief: _ctx.t('BRIEF.LOW.SING') })), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_q_item_label, {
                  key: 2,
                  caption: ""
                }, {
                  default: _withCtx(() => [
                    (_ctx.isDirectoryAsset)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                          _createVNode(_component_q_icon, {
                            name: _ctx.ICONS_NAME.DATABASE_OUTLINE
                          }, null, 8, ["name"]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.t('FROM_DIRECTORY', { database: _ctx.t('BRAND.DATA') })), 1)
                        ]))
                      : (!_ctx.isNexusEntity(_ctx.asset))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.t('NUMBER_OF_LEADS', { count: _ctx.leadCount, lead: _ctx.t('LEAD.LOW.SING'), leads: _ctx.t('LEAD.LOW.PLUR') }, _ctx.leadCount)), 1),
                            (_ctx.leadCount > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.t('IN_BRIEFS', { briefs: _ctx.briefsName })), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                    (_ctx.asset.assetTypes && _ctx.asset.assetTypes.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          (!_ctx.isNexusEntity(_ctx.asset))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " • "))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(_ctx.assetTypesLabels), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })),
          _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.asset.name), 1)
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      }),
      (_ctx.isInBrief)
        ? (_openBlock(), _createBlock(_component_q_item_section, {
            key: 0,
            side: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, _mergeProps(_ctx.BTN_SECONDARY_MD, {
                target: "_blank",
                to: { name: _ctx.ROUTE_DATA.LEAD_OVERVIEW_PAGE.name, params: { id: _ctx.duplicateLead.dobjId } },
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('ACTION.VIEW')), 1)
                ]),
                _: 1
              }, 16, ["to"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onClick", "class"])), [
    [_directive_ripple]
  ])
}